import { renderDate } from "@intrasync/utils";
import { utils } from "@intrasync/utils";
import { ScheduleGridBodyCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";
import { computed } from "mobx";

interface ProductionScheduleLeftBodyCellProps
  extends ScheduleGridBodyCellProps {
  scheduleDate: string;
  rowCount: number;
  rowData: {
    entities: { jobNumber: number }[];
  };
}

const ProductionScheduleLeftBodyCell = (
  props: ProductionScheduleLeftBodyCellProps
) => {
  // console.log('LeftBody props', props);
  const { rowCount, rowData, scheduleDate } = props;
  const clientCount = computed(() => {
    return (
      utils.uniqueArray(
        rowData?.entities?.map((i: { jobNumber: number }) => i.jobNumber)
      ).length || 0
    );
  }).get() as number;
  return (
    <div
      style={{
        border: "1px solid #eee",
        ...props.style,
        ...props.styles,
      }}
    >
      <b>{renderDate(scheduleDate)}</b>
      {rowCount >= 1 && (
        <b>
          {rowCount} {rowCount === 1 ? "piece" : "pieces"}
        </b>
      )}
      {clientCount >= 1 && (
        <b>
          {clientCount} {clientCount === 1 ? "client" : "clients"}
        </b>
      )}
    </div>
  );
};

export default ProductionScheduleLeftBodyCell;
